const DemoTradingAccountContentFive = () => {
  const tradingSteps = [
    {
      step: "Step 1",
      title: "Register",
      description:
        "Create your free Pips account using your email or mobile number. It’s quick, secure, and takes less than a minute.",
    },
    {
      step: "Step 2",
      title: "Get demo balance",
      description:
        "Select the demo option from your dashboard, pick your preferred platform, and customize your virtual balance to match your learning goals.",
    },
    {
      step: "Step 3",
      title: "Explore the platform",
      description:
        "Access real-time market data, practice entries and exits, and test strategies with zero risk, all inside a fully simulated trading environment.",
    },
  ];

  return (
    <div className="trading-guide-section">
      <div className="trading-container">
        <div className="trading-header-row">
          <h2 className="trading-main-headline">Get Started in Minutes</h2>
        </div>

        <div className="trading-visual-wrapper">
          <div className="trading-bg-image">
            <img
              src="/images/trading/demo_trading_account/demo_acc_5.png"
              alt="Trading Demo Account User"
            />
          </div>

          <div className="trading-cards-container">
            <div className="trading-cards-row">
              {tradingSteps.map((item, index) => (
                <div className="trading-step-card" key={index}>
                  <span className="trading-step-number">{item.step}</span>
                  <h3 className="trading-card-title">{item.title}</h3>
                  <p className="trading-card-desc">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoTradingAccountContentFive;
